import angular from 'angular';
import template from './franchise-reports.html';
import FranchiseReportsController from './franchise-reports.controller';
import FranchiseReportsDirective from './FranchiseReports.directive';

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state('drivecoach.admin.franchisereports', {
        url: '/franchise-reports',
        controller: FranchiseReportsController,
        controllerAs: 'vm',
        template: template,
        data: {
            authorizedRoles: [
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];

export default angular
    .module('admin.franchisereports', [FranchiseReportsDirective.name])
    .config(config)
    .controller('FranchiseReportsController', FranchiseReportsController);
